import MiTitle from './title';
import { install } from '../../utils/install';
export default install(MiTitle);
